import { render, staticRenderFns } from "./ApprovalCourse.vue?vue&type=template&id=15ca9b16&scoped=true"
import script from "./ApprovalCourse.vue?vue&type=script&lang=js"
export * from "./ApprovalCourse.vue?vue&type=script&lang=js"
import style0 from "./ApprovalCourse.vue?vue&type=style&index=0&id=15ca9b16&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15ca9b16",
  null
  
)

export default component.exports